"use strict";
/**
 * @module Features
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var helper_1 = require("../helper");

var types_1 = require("../types");

var Error_1 = require("../Error");

var types_2 = require("./types");

function update() {
  return helper_1.actionWrapper({
    group: types_1.Group.Features,
    type: types_2.ActionType.UPDATE
  });
}

exports.update = update;

function validationError(action) {
  switch (action.type) {
    case types_2.ActionType.UPDATE:
      return undefined;

    default:
      return Error_1.invalidActionType(action);
  }
}

exports.validationError = validationError;